/* dataLayer para GTM/GA4: add_to_cart (Cart AJAX) + view_cart (cart drawer) */
(function () {
  function currency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR";
  }
  // C12 (plan ficha móvil 28/08/2026): de dónde sale cada add_to_cart. La barra de compra fija
  // de la ficha deja window.__ifdOrigenAdd = 'barra_fija' antes de pulsar el botón real; si no
  // hay marca, el origen es la plantilla en la que estamos ('ficha' para la de producto).
  function origenPorDefecto() {
    var m = document.querySelector("main[data-template]");
    var t = (m && m.getAttribute("data-template")) || "";
    return t.indexOf("product") === 0 ? "ficha" : (t || "otro");
  }
  function mapItems(raw) {
    return (raw || []).map(function (i) {
      return {
        item_id: i.sku || String(i.id),
        item_name: i.product_title || i.title,
        item_brand: i.vendor,
        item_category: i.product_type,
        item_variant: i.variant_title,
        price: (i.final_price != null ? i.final_price : i.price) / 100,
        quantity: i.quantity || 1
      };
    });
  }

  // --- add_to_cart: interceptar la Cart AJAX API (/cart/add) ---
  if (window.fetch && !window.__gtmCartPatched) {
    window.__gtmCartPatched = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = (args[0] && args[0].url) || args[0];
      // C12: la marca de origen se consume AL SALIR la petición, no al volver, para que no
      // contamine al siguiente añadido si este falla o tarda.
      var origen = null;
      if (typeof url === "string" && url.indexOf("/cart/add") !== -1) {
        origen = window.__ifdOrigenAdd || null;
        window.__ifdOrigenAdd = null;
      }
      return origFetch.apply(this, args).then(function (res) {
        try {
          if (typeof url === "string" && url.indexOf("/cart/add") !== -1) {
            res.clone().json().then(function (data) {
              var items = mapItems((data && data.items) ? data.items : [data]);
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({ ecommerce: null });
              window.dataLayer.push({ event: "add_to_cart", origen: origen || origenPorDefecto(), ecommerce: { currency: currency(), items: items } });
            }).catch(function () {});
          }
        } catch (e) {}
        return res;
      });
    };
  }

  // --- view_cart: cuando se abre el cart drawer (evento 'dialog:open' en <cart-drawer-component>) ---
  if (!window.__gtmViewCartBound) {
    window.__gtmViewCartBound = true;
    document.addEventListener("dialog:open", function (e) {
      var t = e && e.target;
      if (!t || !t.tagName || t.tagName.toLowerCase() !== "cart-drawer-component") return;
      fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: "view_cart",
          ecommerce: {
            currency: cart.currency || currency(),
            value: cart.total_price / 100,
            items: mapItems(cart.items)
          }
        });
      }).catch(function () {});
    }, true);
  }

  // --- C12b: botones de pago acelerado (Shop Pay, Apple Pay…) — no pasan por /cart/add ---
  // Ficha: add_to_cart con origen 'compra_rapida' y el mismo ítem que el add_to_cart normal.
  // Drawer: begin_checkout con origen 'compra_rapida_carrito' y los ítems de /cart.js.
  // El botón de Shop Pay vive en el shadow DOM de <shopify-accelerated-checkout>; el clic es
  // «composed» y composedPath() trae el contenedor. PayPal pinta su botón en un iframe: no se ve.
  if (!window.__gtmAcceleratedBound) {
    window.__gtmAcceleratedBound = true;
    var productoCache = null;
    var productoPromesa = null;

    function urlProducto() {
      var f = document.querySelector("product-form-component[data-product-url]");
      var u = f && f.getAttribute("data-product-url");
      return u ? u.split("?")[0] + ".js" : null;
    }
    function cargarProducto() {
      if (productoCache) return Promise.resolve(productoCache);
      if (productoPromesa) return productoPromesa;
      var u = urlProducto();
      if (!u) return Promise.resolve(null);
      productoPromesa = fetch(u).then(function (r) { return r.json(); }).then(function (p) {
        productoCache = p; return p;
      }).catch(function () { productoPromesa = null; return null; });
      return productoPromesa;
    }
    function lineaSeleccionada(p, form) {
      var idInput = form && form.querySelector('input[name="id"]');
      var id = idInput ? Number(idInput.value) : null;
      var v = null;
      (p.variants || []).forEach(function (x) { if (!v && (id === null || x.id === id)) v = x; });
      if (!v) v = p.variants && p.variants[0];
      if (!v) return null;
      var qInput = form && form.querySelector('input[ref="quantityInput"], input[name="quantity"]');
      var q = qInput ? parseInt(qInput.value, 10) : 1;
      // Misma forma que una línea de /cart/add, para reutilizar mapItems sin duplicar el mapeo.
      return { sku: v.sku, id: v.id, product_title: p.title, vendor: p.vendor, product_type: p.type,
               variant_title: v.title, price: v.price, quantity: (q > 0 ? q : 1) };
    }

    var ultimo = { ficha: 0, carrito: 0 };
    function unaVez(clave) {
      var ahora = Date.now();
      if (ahora - ultimo[clave] < 1000) return false;
      ultimo[clave] = ahora;
      return true;
    }
    function enRuta(e, selector) {
      var ruta = (typeof e.composedPath === "function") ? e.composedPath() : [];
      for (var i = 0; i < ruta.length; i++) {
        var n = ruta[i];
        if (n && n.nodeType === 1 && n.matches && n.matches(selector)) return n;
      }
      return null;
    }

    document.addEventListener("click", function (e) {
      try {
        if (e.__ifdCompraRapida) return;
        // «Más opciones de pago» solo despliega la lista: no es un intento de compra.
        if (enRuta(e, ".shopify-payment-button__more-options, more-payment-options-link")) return;

        var ficha = enRuta(e, '.shopify-payment-button, [data-shopify="payment-button"]');
        if (ficha) {
          e.__ifdCompraRapida = true;
          if (!unaVez("ficha")) return;
          var form = ficha.closest("form") || ficha.closest("product-form-component");
          cargarProducto().then(function (p) {
            if (!p) return;
            var linea = lineaSeleccionada(p, form);
            if (!linea) return;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({ event: "add_to_cart", origen: "compra_rapida",
                                    ecommerce: { currency: currency(), items: mapItems([linea]) } });
          });
          return;
        }

        var carrito = enRuta(e, ".additional-checkout-buttons");
        if (carrito) {
          e.__ifdCompraRapida = true;
          if (!unaVez("carrito")) return;
          fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
            if (!cart || !cart.items || !cart.items.length) return;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({ event: "begin_checkout", origen: "compra_rapida_carrito",
                                    ecommerce: { currency: cart.currency || currency(),
                                                 value: cart.total_price / 100,
                                                 items: mapItems(cart.items) } });
          }).catch(function () {});
        }
      } catch (err) {}
    }, { capture: true, passive: true });

    // Precarga en la ficha, para que el push del clic sea inmediato.
    if (origenPorDefecto() === "ficha") {
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", cargarProducto);
      } else {
        cargarProducto();
      }
    }
  }
})();
